import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const SiteContentContext = createContext({});

export function useSiteContent() { return useContext(SiteContentContext); }

// Provides editable content from /api/content. Public pages read this and
// fall back to their hard-coded defaults if a key isn't present.
export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content`)
      .then((r) => setContent(r.data || {}))
      .catch(() => setContent({}))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, loaded }}>
      {children}
    </SiteContentContext.Provider>
  );
}
